// Generated from design-tokens/tokens/*.tokens.json — do not edit by hand.
// Regenerate with: node design-tokens/scripts/generate.mjs
// Token values for TypeScript consumers (the webapp Emotion theme).

export const primitiveColours = {
  white: "#FFFFFF",
  black: "#000000",
  blue25: "#F7FAFF",
  blue50: "#EDF3FF",
  blue100: "#CADBFE",
  blue200: "#9DBCFB",
  blue300: "#84AAFB",
  blue400: "#4F86FA",
  blue500: "#2569F9",
  blue600: "#074FE9",
  blue700: "#0644C6",
  blue800: "#04369F",
  blue900: "#032772",
  grey10: "#F7F7F8",
  grey25: "#EEEFF1",
  grey50: "#E6E7EA",
  grey100: "#D5D8DD",
  grey200: "#B3B8C1",
  grey300: "#9299A6",
  grey400: "#707A8B",
  grey500: "#4F5A6F",
  grey600: "#2D3B54",
  grey700: "#263247",
  grey800: "#1F2839",
  grey900: "#171F2C",
  grey1000: "#10151E",
  red50: "#FFEEF0",
  red100: "#FECDD1",
  red200: "#FDABB3",
  red300: "#FB8994",
  red400: "#FA5766",
  red500: "#E9071C",
  red600: "#D10519",
  red700: "#BF1642",
  red800: "#A80514",
  red900: "#81040F",
  green50: "#E5F5EB",
  green100: "#D5EEDD",
  green200: "#B3E1C2",
  green300: "#91D3A7",
  green400: "#6FC68B",
  green500: "#4DB870",
  green600: "#2BAB55",
  green700: "#249047",
  green800: "#1D743A",
  green900: "#0F3E1F",
  yellow50: "#FFFBF0",
  yellow100: "#FFF3D3",
  yellow200: "#FFECB6",
  yellow300: "#FFE498",
  yellow400: "#FFD86C",
  yellow500: "#FFC932",
  yellow600: "#FAB800",
  yellow700: "#D69E00",
  yellow800: "#9E7400",
  yellow900: "#423100",
  navy50: "#E2E4F3",
  navy100: "#BDC2E5",
  navy200: "#8C94D1",
  navy300: "#707BC7",
  navy400: "#5B66BE",
  navy500: "#4753B3",
  navy600: "#464E8B",
  navy700: "#313A7E",
  navy800: "#272E63",
  navy900: "#1A1F42",
  pink50: "#FDEDF5",
  pink700: "#A3215F",
  hubspotOrange: "#FF7A59",
  salesforceBlue: "#00A1E0",
  grey0: "#FFFFFF",
  brandDark: "#114ED0",
  brandLight: "#E9F0FF",
} as const;

export const semanticColours = {
  sysPrimaryDefault: primitiveColours.blue500,
  sysPrimaryHover: primitiveColours.blue600,
  sysPrimaryPressed: primitiveColours.blue700,
  sysPrimarySubtle: primitiveColours.blue50,
  sysPrimarySubtleAlt: primitiveColours.blue100,
  sysTextDefault: primitiveColours.grey700,
  sysTextSecondary: primitiveColours.grey500,
  sysTextInactive: primitiveColours.grey300,
  sysTextPlaceholder: primitiveColours.grey400,
  sysTextWhite: primitiveColours.white,
  sysTextBlack: primitiveColours.black,
  sysBackgroundDefault: primitiveColours.white,
  sysBackgroundAlternative: primitiveColours.grey10,
  sysBackgroundInactive: primitiveColours.grey25,
  sysBackgroundInverse: primitiveColours.grey600,
  sysBackgroundOverlay: primitiveColours.grey900,
  sysBackgroundSnow: "#F0F4F7",
  sysBorderDecorative: primitiveColours.grey50,
  sysBorderFunctional: primitiveColours.grey400,
  sysBorderInverse: primitiveColours.white,
  sysLayoutGridBorder: primitiveColours.grey25,
  sysFocusBr: primitiveColours.blue900,
  sysSignalDefault: primitiveColours.grey50,
  sysSignalKeyword: primitiveColours.blue100,
  sysSignalCompetitor: primitiveColours.red100,
  sysSignalPartner: primitiveColours.yellow200,
  sysSignalBuyer: "#D7CFED",
  sysSuccessDefault: primitiveColours.green600,
  sysSuccessHover: primitiveColours.green700,
  sysSuccessPressed: primitiveColours.green800,
  sysSuccessSubtle: primitiveColours.green50,
  sysSuccessSubtleAlt: primitiveColours.green100,
  sysDestructiveDefault: primitiveColours.red500,
  sysDestructiveHover: primitiveColours.red600,
  sysDestructivePressed: primitiveColours.red800,
  sysDestructiveSubtle: primitiveColours.red50,
  sysDestructiveSubtleAlt: primitiveColours.red100,
  sysWarningDefault: primitiveColours.yellow600,
  sysWarningHover: primitiveColours.yellow700,
  sysWarningPressed: primitiveColours.yellow800,
  sysWarningSubtle: primitiveColours.yellow50,
  sysWarningSubtleAlt: primitiveColours.yellow100,
  sysInfoDefault: primitiveColours.blue500,
  sysInfoHover: primitiveColours.blue600,
  sysInfoPressed: primitiveColours.blue700,
  sysInfoSubtle: primitiveColours.blue50,
  sysInfoSubtleAlt: primitiveColours.blue100,
  sysStatusPositive: primitiveColours.green500,
  sysStatusNegative: primitiveColours.red400,
  sysStatusInProgress: primitiveColours.yellow500,
  sysBrandBlueDefault: primitiveColours.blue400,
  sysBrandBlueComplimentary: primitiveColours.blue200,
  sysBrandYellowDefault: primitiveColours.yellow400,
  sysBrandYellowComplimentary: primitiveColours.yellow500,
  sysBrandRedDefault: primitiveColours.red400,
  sysBrandRedComplimentary: primitiveColours.red700,
  sysBrandNavyDefault: primitiveColours.navy700,
  sysBrandNavyComplimentary: primitiveColours.navy200,
  sysProcStagePipeline: "#00CCCC",
  sysProcStagePreTender: "#FAB800",
  sysProcStageStalePreTender: "#FF8001",
  sysProcStageCancelledPreTender: "#4F5A6F",
  sysProcStageOpenTender: "#2BAB55",
  sysProcStageClosedTender: "#E9071C",
  sysProcStageCancelledTender: "#4F5A6F",
  sysProcStageUnknownTender: "#9299A6",
  sysProcStageAwardedContract: "#2569F9",
  sysProcStageLive: "#7660BE",
  sysProcStageExpiredContract: "#E900FF",
  sysProcStageCancelledAward: "#4F5A6F",
  sysChart1: primitiveColours.blue500,
  sysChart2: "#E8590C",
  sysChart3: primitiveColours.green800,
  sysChart4: primitiveColours.grey400,
  sysChart5: primitiveColours.red900,
  sysChart6: "#6345B5",
  sysChart7: primitiveColours.navy700,
  sysChart8: "#0E8FA3",
  sysChart9: primitiveColours.yellow800,
  sysChart10: primitiveColours.red700,
  buildPipelineLight: "#EBFDFF",
  buildPipelineDark: "#028992",
  sysTextWhiteSecondary: "rgb(255 255 255 / 0.9)",
  sysBorderPrimary: primitiveColours.grey100,
  sysOverlayHoverSubtle: "rgb(38 50 71 / 0.04)",
  sysTrackTendersLight: "#F4EFFF",
  sysWinBidsLight: "#FFE9EB",
  sysWorkflowStageToEngageIcon: "#00DFDF",
  sysWorkflowStageToEngageBackground: "#E5FCFC",
  sysWorkflowStageNurturingIcon: "#9E01FF",
  sysWorkflowStageNurturingBackground: "#8B5CF6",
  sysWorkflowStageMeetingBookedIcon: "#FFCA09",
  sysWorkflowStageMeetingBookedBackground: "#F5E6FF",
  sysWorkflowStageBidCreatedIcon: primitiveColours.blue500,
  sysWorkflowStageBidCreatedBackground: primitiveColours.blue100,
  sysWorkflowStageDisqualifiedIcon: primitiveColours.grey400,
  sysWorkflowStageDisqualifiedBackground: primitiveColours.grey25,
  sysWorkflowStageWonIcon: primitiveColours.green600,
  sysWorkflowStageWonBackground: primitiveColours.green100,
  sysWorkflowStageLostIcon: primitiveColours.red500,
  sysWorkflowStageLostBackground: primitiveColours.red50,
  sysEditorHighlightPurpleText: "#785DC1",
  sysEditorHighlightPurpleBackground: "#D7CFED",
} as const;

export const fontTokens = {
  fontSize1100: "60px",
  fontSize1000: "50px",
  fontSize900: "42px",
  fontSize800: "35px",
  fontSize700: "29px",
  fontSize600: "24px",
  fontSize500: "20px",
  fontSize400: "17px",
  fontSize300: "14px",
  fontSize200: "12px",
  fontSize100: "10px",
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
} as const;

export const lineHeightTokens = {
  lineHeightNarrow: 1.25,
  lineHeightRegular: 1.5,
  lineHeightWide: 1.75,
} as const;

export const sizeTokens = {
  size4: "4px",
  size8: "8px",
  size12: "12px",
  size16: "16px",
  size20: "20px",
  size24: "24px",
  size32: "32px",
  size40: "40px",
  size48: "48px",
  size56: "56px",
  size64: "64px",
  size80: "80px",
  size96: "96px",
  size120: "120px",
  size152: "152px",
  size192: "192px",
} as const;

export const spacerTokens = {
  spacerXs: "4px",
  spacerSm: "8px",
  spacerMd: "16px",
  spacerLg: "24px",
  spacerXl: "32px",
  spacer2xl: "48px",
  spacer3xl: "64px",
  spacer4xl: "96px",
} as const;

export const radiusTokens = {
  radiusSm: "2px",
  radiusMd: "4px",
  radiusLg: "8px",
  radiusXl: "16px",
} as const;

export const shadowTokens = {
  shadowLg: "0 4px 12px rgb(0 0 0 / 0.12)",
} as const;
